import { Model } from '@/models/Model';
import client from '@/support/Client';
export class UserSubjectSummary extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'UserSubjectSummary';
        this.$endpoint = '/subjects/summary';
        this.$fillable = [];
    }
    load() {
        const payload = {};
        if (this.$includes.length) {
            payload.with = this.$includes;
        }
        payload.filters = this.filters;
        return client('get', this.$endpoint, payload);
    }
}
